"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var useRafState_1 = __importDefault(require("../useRafState"));
var domTarget_1 = require("../shared/domTarget");
var useIsomorphicLayoutEffectWithTarget_1 = __importDefault(require("../factory/useIsomorphicLayoutEffectWithTarget"));
function useSize(target) {
  var _a = (0, useRafState_1["default"])(function () {
      var el = (0, domTarget_1.getTargetElement)(target);
      return el ? {
        width: el.clientWidth,
        height: el.clientHeight
      } : undefined;
    }),
    state = _a[0],
    setState = _a[1];
  (0, useIsomorphicLayoutEffectWithTarget_1["default"])(function () {
    var el = (0, domTarget_1.getTargetElement)(target);
    if (!el) {
      return;
    }
    var resizeObserver = new resize_observer_polyfill_1["default"](function (entries) {
      entries.forEach(function (entry) {
        var _a = entry.target,
          clientWidth = _a.clientWidth,
          clientHeight = _a.clientHeight;
        setState({
          width: clientWidth,
          height: clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [], target);
  return state;
}
exports["default"] = useSize;